import React, { useEffect, useState } from 'react'
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputTextField from '../../../../components/input/inputTextField';
import { useTranslation } from 'react-i18next';
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { ReactComponent as Document } from '../../../../assets/icons/document.svg'
import { routeName } from '../../../../routes/routeName';
import { swalError, swalSuccess } from '../../../../components/alert/swal';
import UploadFile from '../../../../components/upload/UploadFile';

export default function Resolution() {
    const { id } = useParams();
    const [form, setForm] = useState<any>()
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [listAgendas, setListAgendas] = useState<any[]>([]);

    const [resolution, setResolution] = useState<any>()
    const [detail, setDetail] = useState<any>()
    const getDetail = async () => {
        await MeetingRoomApi.resolution(id).then((res: any) => {
            if (res.status < 300) {
                setResolution(res.data.data);

                setForm({
                    ...form, resolution_fiile: res.data.data.resolution_fiile
                })
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
        })
    }
    const getListAgendas = async () => {
        const res = await MeetingRoomApi.listAgendas(id);
        const data = res.data
        setListAgendas(data.filter((x: any) => x?.status !== 'delete'))
    }
    const getFindById = async () => {
        await MeetingRoomApi.findById(id).then((res: any) => {
            if (res.status < 300) {
                setDetail(res.data.data);
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
            getListAgendas()
            getFindById()

        }

    }, [])

    const handleUpdate = async (file: any) => {

        const formData = new FormData();
        //DRAFT
        formData.append('file', file[0]);
        await MeetingRoomApi.uploadMeetingFile(formData, id).then((res: any) => {
            if (res.status < 300) {

                setForm({
                    ...form, resolution_fiile: res.data
                })



            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }

    const handleSend = async () => {
        await MeetingRoomApi.send_email_resolution(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess('เผยแพร่มติที่ประชุม เรียบร้อยแล้ว')
                getDetail()
                getListAgendas()
                getFindById()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')

        })
    }
    const handleSubmit = async () => {
        const body = {
            id_meeting_room_file: form?.resolution_fiile?.id_meeting_room_file
        }
        await MeetingRoomApi.postResolution(body, id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess('บันทึก เรียบร้อยแล้ว')
                getDetail()
                getListAgendas()
                getFindById()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')

        })
    }

    return (
        <div className='w-full mt-[40px]'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                <Typography variant='h6'>{t('รายงานการประชุม')}</Typography>
                {/* <AddSquare onClick={() => setForm({ ...form, meeting_agenda_file: form?.meeting_agenda_file?.length > 0 ? [...form?.meeting_agenda_file, {}] : [{}] })} /> */}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '5px' }}>
                {form?.resolution_fiile ?
                    <div style={{
                        border: "2px dotted #C1C3C7",
                        borderRadius: "10px",
                        padding: "15px 15px",
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Document />
                            <div style={{ display: "flex", alignItems: 'center' }}>
                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{form?.resolution_fiile?.file_name}</Typography>
                            </div>
                        </div>

                        <ButtonOutlined
                            onClick={() => {
                                // handleSubmit(inputValueFormStudent.information);
                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + form?.resolution_fiile?.file_path + form?.resolution_fiile?.file_name, '_blank');

                            }}
                            buttonName="ดาวน์โหลดไฟล์"
                            btnProps={{
                                width: "150px",
                                // border: '#0F9F0C'
                            }}
                        />
                    </div> : <UploadFile
                        onDrop={(file) => {
                            handleUpdate(file);
                        }}
                        // enableFormatImage
                        onDeleteFile={() => {
                            // setFile(null);
                        }}


                    // formatText='ขนาดไม่เกิน 10MB'
                    // customFormat={["image/jpeg", "image/jpg", "image/png"]}

                    />}

            </div>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
                {listAgendas?.map((item: any, index: number) => {
                    return (
                        <Accordion defaultExpanded sx={{
                            // backgroundColor: "#4A4A4A",
                            color: "#4A4A4A",
                            // borderRadius: "18px",
                            overflow: 'hidden'
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    // backgroundColor: "#4A4A4A",
                                    padding: "10px 16px",
                                    fontWeight: "bold",
                                    margin: '0px',
                                    "& .MuiAccordionSummary-content": {
                                        margin: '0px'
                                    },
                                    "& .MuiAccordionSummary-content.Mui-expanded": {
                                        margin: '0px'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e?.stopPropagation()}>

                                    <Typography sx={{ fontWeight: "bold", color: '#4A4A4A' }}>วาระที่ {index + 1}.1 {item?.meeting_agenda_name}</Typography>
                                    <RemoveRedEyeOutlinedIcon sx={{ color: '#4A4A4A' }} onClick={() => {
                                        navigate(routeName.cms.DetailAgenda.replace(':id', `${id}`) + `?id=${item?.id_meeting_agenda}&mode=VIEW`)

                                    }} />
                                </Box>

                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <SubAgende idAgenda={item?.id_meeting_agenda} index={index + 1} />
                            </AccordionDetails>
                        </Accordion>
                    )
                })}

            </Box>
            <section className="w-full col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(-1);
                    }}
                    buttonName="ย้อนกลับ"
                    btnProps={{
                        width: "150px",
                    }}
                />


                {!['COMPLETED'].includes(detail?.meeting_room_status) && <>

                    <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            // handleSubmit()
                            handleSubmit()
                        }}
                        mode="save"
                        buttonName="บันทึก"
                        btnProps={{
                            width: "150px",
                        }}
                    />
                    <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            handleSend()
                        }}
                        mode="send"
                        buttonName="เผยแพร่และส่งอีเมลไปยังผู้ที่เกี่ยวข้อง"
                        btnProps={{
                            // width: "150px",
                        }}
                    />
                </>}
            </section>
        </div>
    )
}
function SubAgende(props: any) {
    const { idAgenda, index } = props
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate: NavigateFunction = useNavigate();

    const [subListAgendas, setSubListAgendas] = useState<any[]>([]);
    const getListSubAgendas = async () => {
        const res = await MeetingRoomApi.getAgendas(id, idAgenda);
        const data = res.data
        setSubListAgendas(data?.sub_agenda.filter((x: any) => x?.status !== 'delete'))
    }

    useEffect(() => {
        if (idAgenda) {
            getListSubAgendas()
        }

    }, [idAgenda])
    return (
        <>
            {subListAgendas?.length > 0 ? subListAgendas?.map((obj: any, i: number) => {
                return (
                    <Accordion defaultExpanded sx={{
                        // backgroundColor: "#4A4A4A", color: "white",
                        // borderRadius: "18px",
                        overflow: 'hidden'
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            sx={{
                                // backgroundColor: "#4A4A4A",
                                padding: "10px 16px",
                                fontWeight: "bold",
                                margin: '0px',
                                "& .MuiAccordionSummary-content": {
                                    margin: '0px'
                                },
                                "& .MuiAccordionSummary-content.Mui-expanded": {
                                    margin: '0px'
                                }
                            }}
                        >
                            <Typography> {index}.{i + 1}.1 {obj?.meeting_agenda_name}</Typography>

                        </AccordionSummary>
                        <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column' }}>
                            <InputTextField heading='รายละเอียดมติที่ประชุม' value={obj?.meeting_agenda_resolution || ''} multiline minRow={6} disabled />
                        </AccordionDetails>
                        {/* <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', justifyContent: 'space-between' }} >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                                <Typography> {index}.{i + 1}.1 {obj?.meeting_agenda_name}</Typography>
                            </Box>



                        </Box> */}
                    </Accordion>
                )
            }) : <Typography>{t('SETUP_COURSE_OPENING_NO_DATA')}...</Typography>}
        </>
    )
}

